import React, { useState } from "react";
import Overlay from '../Overlay/Overlay';
import { DmsConfigTable } from './DMSConfigs/DMSConfigTable';
import './ViewDetails.scss';

const constants = {
    linkText: 'View Details',
    configurations: 'Configurations',
    dmsAccounts: 'DMS Accounts:',
    overlayStyle: {width: '700px'},
    subscriptionDetails: 'Subscription Details:'
};

export const ViewDetails = React.memo(({app, api, departments, apiName}) => {
    const [open, setOpen] = useState(false);
    return (
      <>
        <span
          className='view-details__link'
          onClick={() => setOpen(true)}
        >
          {constants.linkText}
        </span>
        <Overlay 
          active={open}
          customeStyle={constants.overlayStyle}
          title={constants.configurations}
          onOverlayClose={() => setOpen(false)}
          hideFirstButton
          hideSecondButton
        >
          {departments.length &&
            <div>
              <div>
                <p>
                  <span className="view-details__title">App Name: </span>
                  {app}
                </p>
                <p>
                  <span className="view-details__title">API Name: </span>
                  {apiName}
                </p>
              </div>
              <div className="view-details__dms-accounts">
                <p className='view-details__title'>{constants.dmsAccounts}</p>
                <DmsConfigTable departments={departments}/>
              </div>
            </div>
          }
        </Overlay>      
      </>
    )
  });